import { useWebView } from '@qicgroupdoha/qic-use'

export const useLinkTarget = () => {
  const { isWebView } = useWebView()
  const isInWebView = isWebView()

  const getLinkTarget = (fallback = '_blank') => (isInWebView ? '_self' : fallback)

  return { getLinkTarget }
}
